import * as RewardsStyles from './Rewards.styles';

import tracking from '../../../../utils/tracking';
import { TrackingEvent } from '../../../../utils/tracking/types';
import { currencyDefaults, locale } from '../../../../utils/intl';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ReferralState, ReferralStateDescription } from 'foundshared/src/api/referrals/constants';
import { useEffect } from 'react';

import type { Referral } from 'foundshared/src/api/referrals/types';


const referralStateDescription = (referralState: ReferralState): ReferralStateDescription => {
  switch (referralState) {
    case ReferralState.COMPLETED:
      return ReferralStateDescription.COMPLETED;
    case ReferralState.JOINED:
      return ReferralStateDescription.JOINED;
    case ReferralState.ORDERED:
      return ReferralStateDescription.ORDERED;
    case ReferralState.NEW:
    default:
      return ReferralStateDescription.NEW;
  }
};

type RewardsProps = {
  items: Referral[];
  isShareSupported: boolean;
  onClickHandler: () => void;
};

const currency = new Intl.NumberFormat(locale, {
  ...currencyDefaults,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function Rewards({ items = [], isShareSupported, onClickHandler }: RewardsProps) {
  const { classes } = RewardsStyles.useWrapper();

  const description = (state: ReferralState) => referralStateDescription(state);

  useEffect(() => {
    tracking.event(TrackingEvent.REFERRAL_REWARDS);
  }, []);

  return (
    <Box>
      {items.length > 0 ? (
        <>
          {items.map((item) => (
            <Box key={item.id} className={classes.root}>
              <Box>
                <Typography variant="h6" component="h6">
                  {item.name}
                </Typography>
                <Typography variant="subtitle1" component="p">
                  {description(item.state as ReferralState)}
                </Typography>
              </Box>
              {item.state === ReferralState.COMPLETED && (
                <Typography className={classes.amount} variant="h4" component="h4">
                  {!!item.referralBonus && currency.format(item.referralBonus)}
                </Typography>
              )}
              {item.state === ReferralState.JOINED && isShareSupported && (
                <Box display="flex" flexDirection="column" justifyContent="center">
                  <Button className={classes.button} onClick={onClickHandler} fullWidth>
                    Remind
                  </Button>
                </Box>
              )}
            </Box>
          ))}
        </>
      ) : (
        <Box paddingTop={1}>
          <Typography variant="h6" component="p">
            You haven’t referred anyone yet!
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default Rewards;
